
export const fortniteProducts = [
  {
    id: '1',
    title: 'Fortnite - 1000 V-Bucks',
    price: 7.99,
    originalPrice: 9.99,
    image: 'https://public.readdy.ai/ai/img_res/94682510a453113e45b87db33050eef2.jpg',
    platform: 'Epic Games',
    rating: 4.8,
    category: 'currency'
  },
  {
    id: '2',
    title: 'Fortnite - 2800 V-Bucks',
    price: 19.99,
    originalPrice: 24.99,
    image: 'https://readdy.ai/api/search-image?query=fortnite%20v-bucks%20currency%20digital%20card%20purple%20background%20gaming%20aesthetic%20clean%20modern%20design%20large%20amount&width=300&height=200&seq=vbucks2800&orientation=landscape',
    platform: 'Epic Games',
    rating: 4.9,
    category: 'currency'
  },
  {
    id: '3',
    title: 'Fortnite - 5000 V-Bucks',
    price: 31.99,
    originalPrice: 39.99,
    image: 'https://readdy.ai/api/search-image?query=fortnite%20v-bucks%20currency%20digital%20card%20purple%20background%20gaming%20aesthetic%20clean%20modern%20design%20premium%20pack&width=300&height=200&seq=vbucks5000&orientation=landscape',
    platform: 'Epic Games',
    rating: 4.7,
    category: 'currency'
  },
  {
    id: '4',
    title: 'Fortnite - 13500 V-Bucks',
    price: 79.99,
    originalPrice: 99.99,
    image: 'https://readdy.ai/api/search-image?query=fortnite%20v-bucks%20currency%20digital%20card%20purple%20background%20gaming%20aesthetic%20clean%20modern%20design%20ultimate%20pack&width=300&height=200&seq=vbucks13500&orientation=landscape',
    platform: 'Epic Games',
    rating: 4.8,
    category: 'currency'
  },
  {
    id: '5',
    title: 'Fortnite Battle Pass - Chapter 5',
    price: 9.50,
    image: 'https://readdy.ai/api/search-image?query=fortnite%20battle%20pass%20chapter%205%20season%20gaming%20card%20purple%20background%20modern%20design%20epic%20games&width=300&height=200&seq=battlepass&orientation=landscape',
    platform: 'Epic Games',
    rating: 4.9,
    category: 'battlepass'
  },
  {
    id: '6',
    title: 'Fortnite Crew Subscription - 1 Month',
    price: 11.99,
    image: 'https://readdy.ai/api/search-image?query=fortnite%20crew%20subscription%20monthly%20pass%20purple%20background%20gaming%20aesthetic%20premium%20membership%20card&width=300&height=200&seq=crew&orientation=landscape',
    platform: 'Epic Games',
    rating: 4.6,
    category: 'subscription'
  },
  {
    id: '7',
    title: 'Fortnite - Starter Pack',
    price: 3.99,
    originalPrice: 4.99,
    image: 'https://readdy.ai/api/search-image?query=fortnite%20starter%20pack%20beginner%20bundle%20purple%20background%20gaming%20aesthetic%20clean%20modern%20design&width=300&height=200&seq=starter&orientation=landscape',
    platform: 'Epic Games',
    rating: 4.5,
    category: 'bundle'
  },
  {
    id: '8',
    title: 'Fortnite - Save the World',
    price: 15.99,
    originalPrice: 19.99,
    image: 'https://readdy.ai/api/search-image?query=fortnite%20save%20the%20world%20game%20mode%20purple%20background%20gaming%20aesthetic%20action%20adventure&width=300&height=200&seq=stw&orientation=landscape',
    platform: 'Epic Games',
    rating: 4.4,
    category: 'gamemode'
  }
];

export const featuredProducts = [
  {
    id: '9',
    title: 'Epic Games Store Gift Card - £10',
    price: 10.00,
    image: 'https://readdy.ai/api/search-image?query=epic%20games%20store%20gift%20card%20digital%20voucher%20purple%20background%20gaming%20aesthetic%20clean%20modern%20design&width=300&height=200&seq=epic10&orientation=landscape',
    platform: 'Epic Games',
    rating: 4.8,
    category: 'giftcard'
  },
  {
    id: '10',
    title: 'Epic Games Store Gift Card - £25',
    price: 25.00,
    image: 'https://readdy.ai/api/search-image?query=epic%20games%20store%20gift%20card%20digital%20voucher%20purple%20background%20gaming%20aesthetic%20clean%20modern%20design%20premium&width=300&height=200&seq=epic25&orientation=landscape',
    platform: 'Epic Games',
    rating: 4.9,
    category: 'giftcard'
  },
  {
    id: '11',
    title: 'Epic Games Store Gift Card - £50',
    price: 50.00,
    image: 'https://readdy.ai/api/search-image?query=epic%20games%20store%20gift%20card%20digital%20voucher%20purple%20background%20gaming%20aesthetic%20clean%20modern%20design%20ultimate&width=300&height=200&seq=epic50&orientation=landscape',
    platform: 'Epic Games',
    rating: 4.7,
    category: 'giftcard'
  }
];
